import * as React from 'react';
import * as styles from './BuilderReviews.css';
import { Section } from '../Section';
import { useFrameEvents } from './hooks/useFrameEvents';

interface IBuilderReviewsProps {
  url: string;
  title: string;
}

export const BuilderReviews: React.FC<IBuilderReviewsProps> = ({ url, title }) => {
  const { frameHeight } = useFrameEvents();

  return (
    <Section title={title} dataName="BuilderReviews">
      <iframe className={styles['builder-reviews']} height={frameHeight} width="100%" src={url} />
    </Section>
  );
};
